<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">
						Ny brist
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body flawmodal">
					<FlawView
						@goBack="cancel"
						@flaw-added="flawAdded"
						@flaw-fixed="setFixed"
						@continueWithoutAdding="continueWithoutAdding"
					/>
				</section>
			</div>
		</div>
	</div>
</template>
<script>
import FlawView from '../FlawView.vue';
export default {
	components: {
		FlawView
	},
	methods: {
		cancel() {
			this.$emit('cancel');
		},
		flawAdded(item) {
			this.$emit('flaw-added', item);
		},
		setFixed(item) {
			this.$emit('flaw-fixed', item);
		},
		continueWithoutAdding(item) {
			this.$emit('continueWithoutAdding', item);
		}
	}
};
</script>
<style lang="scss">
.flawmodal {
  .title {
    display: none !important;
  }

  .field.check {
    max-width: 90px !important;
  }

  .main-view {
    padding-top: 0px !important;
  }

  .label {
    color: #23282d !important;
  }
}
</style>
